import { Text, LegacyStack, Thumbnail } from '@shopify/polaris';

const ProductMiniStripe = ({ product }) => (
  <LegacyStack horizontal spacing="baseTight" alignment="center">
    <Thumbnail source={product.images?.[0] || ''} alt={product.family} size="small" />
    <LegacyStack vertical spacing="none">
      <Text variant="bodySm" fontWeight="bold">
        <div style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {product.title}
        </div>
      </Text>
      <Text variant="bodySm" fontWeight="semibold" color="subdued">
        {product.family}
      </Text>
    </LegacyStack>
  </LegacyStack>
);

export default ProductMiniStripe;
